import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

const AccountInfo = ({ profile, rpmStatus, ccmStatus, pcmStatus }) => (
  <Table borderless border="0" cellSpacing="0" cellPadding="0">
    <thead>
      <tr>
        <th colSpan="2">
          <div className="pagination-container">
            <h5>Account Info</h5>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td />
        <td>
          <span className="subheader">RPM Status:</span>
          <span>{rpmStatus}</span>
          <span className="subheader">CCM Status:</span>
          <span>{ccmStatus}</span>
          <span className="subheader">PCM Status:</span>
          <span>{pcmStatus}</span>
          <span className="subheader">Patient ID:</span>
          <span className="text-transform-none">{profile.guid}</span>
        </td>
      </tr>
    </tbody>
  </Table>
);

AccountInfo.propTypes = {
  profile: PropTypes.shape().isRequired,
  ccmStatus: PropTypes.string.isRequired,
  rpmStatus: PropTypes.string.isRequired,
  pcmStatus: PropTypes.string,
};

export default AccountInfo;
